class ResizableChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 500
    };
  }

  componentDidMount() {
    let onResize = () => {
      let node = ReactDOM.findDOMNode(this);
      let width = node.parentNode.getBoundingClientRect().width;

      this.setState({ width });
    };

    mc.ui.on("resize", onResize);

    onResize();
  }

  componentWillUnmount() {
    mc.ui.off("resize");
  }
}

module.exports = ResizableChart;